import { Link, useNavigate, useParams } from 'react-router-dom';
import { usePlaces } from '@/hooks/usePlaces';
import { useFavorites } from '@/hooks/useFavorites';
import { formatDriveTime, formatDistance } from '@/lib/formatting';
import { HeartIcon } from '@/components/Icons';
import { MapActions } from '@/components/MapActions';
import { PlaceRowNav } from '@/components/PlaceRowNav';
import { Bilingual } from '@/components/Bilingual';
import { formatClockInText } from '@shared/clock';
import { glossInline } from '@shared/ptEn';
import { OpeningHoursBlock } from '@/components/OpeningHours';

export function PlaceDetailPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { places, loading } = usePlaces();
  const { isFavorite, toggle } = useFavorites();
  const place = places.find((p) => p.slug === slug);

  if (loading && !place) {
    return <div className="skeleton" style={{ height: 200 }} />;
  }
  if (!place) {
    return (
      <div className="card empty-state">
        <p>Place not found.</p>
        <Link to="/places">Back to Places</Link>
      </div>
    );
  }

  return (
    <div>
      <button type="button" className="btn btn-ghost" onClick={() => navigate(-1)}>
        ← Back
      </button>
      {place.imageUrl ? <img className="place-card-image place-card-image--hero" src={place.imageUrl} alt="" /> : null}
      <div className="page-header">
        <h1 className="page-title">
          <Bilingual text={place.name} />
        </h1>
        <p className="page-subtitle">
          {formatDistance(place.distance_km)} · {formatDriveTime(place.estimated_drive_minutes)} from Rocha Brava
        </p>
      </div>
      <div className="card">
        <p>
          <Bilingual text={place.address} />
        </p>
        {place.notes && <p style={{ marginTop: 10 }}>{glossInline(formatClockInText(place.notes))}</p>}
        {place.hoursNote && <p className="muted" style={{ marginTop: 10 }}>{formatClockInText(place.hoursNote)}</p>}
        <OpeningHoursBlock openingHours={place.openingHours} />
        <div className="place-card__badges" style={{ marginTop: 12 }}>
          <PlaceRowNav place={place} />
        </div>
        <MapActions
          address={place.address}
          lat={place.lat}
          lng={place.lng}
          phone={place.phone}
          website={place.website}
          name={place.name}
        />
        <div className="action-row">
          <button
            type="button"
            className={`action-btn ${isFavorite(place.id) ? 'is-on' : ''}`}
            onClick={() => toggle(place.id)}
          >
            <HeartIcon filled={isFavorite(place.id)} /> {isFavorite(place.id) ? 'Saved' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
}
